import React from 'react';
import { Box, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TextV2 } from '@insights-ltd/design-library/components';
import { IJob } from 'types/job';
import Navigation from 'components/Navigation';

type SearchHeaderProps = {
  job: IJob;
};

const SearchHeader = ({ job }: SearchHeaderProps) => {
  return (
    <Container disableGutters>
      <Grid container size={12} sx={{ flexDirection: 'column' }}>
        <Navigation
          breadcrumbs={[
            { route: '/jobs', children: 'jobs' },
            {
              route: `/jobs/${job.id}`,
              children: job.id,
            },
            { route: '', children: `String Search` },
          ]}
        />
        <Box sx={{ marginTop: '10px' }}>
          <TextV2>
            {job.title}&nbsp;&nbsp;{job.id}
          </TextV2>
        </Box>
      </Grid>
    </Container>
  );
};

export default SearchHeader;
